import { useEffect, useRef, useState } from 'react';

export function useTrimHandleHover() {
  const [showTrimHandlesOnHover, setShowTrimHandlesOnHover] = useState<'start' | 'end' | null>(null);
  const segmentRef = useRef<HTMLDivElement | null>(null);
  const showTrimHandlesOnHoverRef = useRef(showTrimHandlesOnHover);
  showTrimHandlesOnHoverRef.current = showTrimHandlesOnHover;

  useEffect(() => {
    const node = segmentRef.current;
    if (!node) {
      return;
    }
    const handleMouseMove = (e: MouseEvent) => {
      if (!segmentRef.current) {
        return;
      }

      const rect = segmentRef.current.getBoundingClientRect();
      const mouseX = e.clientX;
      const segmentLeft = rect.left;
      const segmentRight = rect.right;
      const hoverThreshold = 20;
      const trimBarsWidth = 18;

      const isNearLeftEdge =
        mouseX >= segmentLeft - (showTrimHandlesOnHoverRef.current ? trimBarsWidth : 0) &&
        mouseX <= segmentLeft + hoverThreshold;
      const isNearRightEdge =
        mouseX <= segmentRight + (showTrimHandlesOnHoverRef.current ? trimBarsWidth : 0) &&
        mouseX >= segmentRight - hoverThreshold;

      let hoverState: 'start' | 'end' | null = null;
      if (isNearLeftEdge) {
        hoverState = 'start';
      } else if (isNearRightEdge) {
        hoverState = 'end';
      }
      setShowTrimHandlesOnHover(hoverState);
    };

    const handleMouseLeave = () => {
      setShowTrimHandlesOnHover(null);
    };

    node.addEventListener('mousemove', handleMouseMove);
    node.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      node.removeEventListener('mousemove', handleMouseMove);
      node.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return {
    showTrimHandlesOnHover,
    segmentRef
  };
}
